import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import classNames from 'classnames'

import GridListThSelectableComponent from './GridListThSelectable'
import GridListTh from './GridListTh'
import GridListThManage from './GridListThManage'
import GridListRow from './GridListRow'
import './GridListTable.scss'

const GridListTable = ({ sortedBy, sortedAsc, setSortedBy, setSortedAsc, selectedIds, onRowSelect, renderedColumns, isBordered, filterProps, gridProps = {}, onSelectAll, isSelectedAll, sortProps = {}, setPaginationCurrent, setRenderedColumns, displayData }) => {
  const { rowProps = {}, color, gridView, isCompact, isNarrow, disableMobile, showManageColumns, hideHead, hideSelectAll, transparentHead, isScrollable, hasSelectAll } = gridProps
  const { rowBlank, rowId = '_id', disabledIds, disabledClickIds } = rowProps
  const { onSort, enableSort } = sortProps

  const RenderGridTable = () => {
    return (
      <table
        className={classNames(
          'viso-grid-list-table',
          `viso-grid-list-table--${gridView}`,
          !filterProps && 'viso-grid-list-table--no-filters',
          isCompact && 'viso-grid-list-table--compact',
          !disableMobile && 'viso-grid-list-table--mobile-enabled',
          isBordered && 'viso-grid-list-table--bordered'
        )}>
        {!hideHead &&
          <thead className={classNames(
            'viso-grid-list-table__head',
            `viso-grid-list-table__head--${gridView}`,
            !disableMobile && 'viso-grid-list-table__head--mobile-enabled'
          )}>
            <tr className={classNames('viso-grid-list-table__head-row', `viso-grid-list-table__head-row--${gridView}`)}>
              {hasSelectAll && (() => {
                const selectedAll = typeof isSelectedAll === 'function' ? isSelectedAll() : !!isSelectedAll
                return (
                  <GridListThSelectableComponent
                    color={color}
                    onSelect={onSelectAll}
                    isSelectedAll={selectedAll}
                    hideSelectAll={hideSelectAll}
                  />
                )
              })()}
              {renderedColumns.map(def => def.isVisible &&
                <GridListTh
                  onSort={onSort}
                  changePage={setPaginationCurrent}
                  key={def.column}
                  def={def}
                  sortedBy={sortedBy}
                  sortedAsc={sortedAsc}
                  setSortedBy={setSortedBy}
                  setSortedAsc={setSortedAsc}
                  enableSort={enableSort}
                  transparentHead={transparentHead}
                  isCompact={isCompact}
                  isNarrow={isNarrow}
                  isBordered={isBordered}
                />
              )}
              {showManageColumns && <GridListThManage defs={renderedColumns} onChange={setRenderedColumns} />}
            </tr>
          </thead>
        }
        <tbody className={classNames(
          'viso-grid-list-table__body',
          `viso-grid-list-table__body--${gridView}`,
          !disableMobile && 'viso-grid-list-table__body--mobile-enabled'
        )}>
          {displayData().length > 0 ? displayData().map((item, index) => {
            return (
              <GridListRow
                key={index}
                disabled={disabledIds?.includes(item[rowId])}
                disabledClick={disabledClickIds?.includes(item[rowId])}
                gridProps={gridProps}
                onRowSelect={onRowSelect}
                selectedIds={selectedIds}
                renderedColumns={renderedColumns}
                item={item}
                sortedBy={sortedBy}
                rowBlank={rowBlank}
                isBordered={isBordered}
              />
            )
          })
            : rowBlank && <GridListRow gridProps={gridProps} rowBlank={rowBlank} isBordered={isBordered} />
          }
        </tbody>
      </table>
    )
  }

  if (isScrollable) {
    return (
      <Scrollbars
        style={{ width: '100%', height: 'auto', flexGrow: 1 }}
        universal
        autoHide
        autoHideDuration={1}
        autoHeight
        autoHeightMin={10}
        autoHeightMax={1000}
        renderThumbVertical={(props) => <div {...props} className='thumb-vertical' />}
      >
        <div className={classNames('viso-grid-list-table__scroll', isBordered && 'viso-grid-list-table__scroll--bordered')}>
          <RenderGridTable />
        </div>
      </Scrollbars>
    )
  }

  return (
    <RenderGridTable />
  )
}

export default GridListTable